import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { portalApi } from "@/lib/portalApi";

export default function PortalListDetailPage() {
  const { id } = useParams();
  const [list, setList] = useState(null);
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const load = () =>
    portalApi.lists
      .show(id)
      .then((data) => setList(data.mailing_list))
      .catch((err) => setError(err.message));

  useEffect(() => {
    load();
  }, [id]);

  async function onAdd(e) {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await portalApi.lists.addSubscriber(id, { email, name });
      setEmail("");
      setName("");
      await load();
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  }

  async function onRemove(subscriberId) {
    try {
      await portalApi.lists.removeSubscriber(id, subscriberId);
      await load();
    } catch (err) {
      setError(err.message);
    }
  }

  if (!list && !error) return <p className="muted">Loading…</p>;

  return (
    <>
      <p>
        <Link to="/portal/lists" style={{ textDecoration: "underline" }}>
          ← Lists
        </Link>
      </p>
      <h1>{list?.name || "List"}</h1>
      <p className="muted">{list?.description || "Subscribers on this list"}</p>
      {error && <div className="portal-alert portal-alert--error">{error}</div>}

      <div className="portal-card">
        <h2>Add subscriber</h2>
        <form className="portal-form" onSubmit={onAdd}>
          <label>
            Email
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} />
          </label>
          <label>
            Name
            <input value={name} onChange={(e) => setName(e.target.value)} />
          </label>
          <button className="btn" type="submit" disabled={busy}>
            {busy ? "Adding…" : "Add"}
          </button>
        </form>
      </div>

      <div className="portal-card">
        <h2>Subscribers</h2>
        {!list?.subscribers?.length ? (
          <p className="muted">No subscribers yet.</p>
        ) : (
          <table className="portal-table">
            <thead>
              <tr>
                <th>Email</th>
                <th>Name</th>
                <th>Status</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {list.subscribers.map((s) => (
                <tr key={s.id}>
                  <td>{s.email}</td>
                  <td>{s.name}</td>
                  <td>{s.status}</td>
                  <td>
                    <button type="button" className="btn btn--ghost" onClick={() => onRemove(s.id)}>
                      Remove
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </>
  );
}
